<template>
	<div>
		<div class="pt-1">
			<div class="form-desc  pt-3">
				{{ t('editVariablesDescText','editVariablesDescText') }}
			</div>
		</div>
		<div class="col-6 pl-0">
			<transition name="fade">
        <ResponseInfo v-if="getResponseInfo.responseName == 'editVariablesContents'" />
      </transition>
			<div class="" v-if="getAllDocTypes">
				<div class="row">
					<b-form-group class="m-0 col-lg-12 col-sm-12">
						<b-input-group>
							<b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
									<b-input-group-text slot="prepend" class="col-12 pretext">
										<span class="pretext-span">{{ t('selectDocTypeLabel','selectDocTypeLabel') }}</span>
									</b-input-group-text>
							</b-input-group-prepend>
							<b-form-select @change="selectDocType" v-model="documentType" class="text-capitalize">
								<option value="" disabled>{{ t('selectDocTypeText','selectDocTypeText') }}</option>
								<option v-for="docType in getAllDocTypes" :key="docType.id" :value="{id: docType.id, name: docType.name}">{{docType.name}}</option>
							</b-form-select>
						</b-input-group>
					</b-form-group>					
				</div>
			</div>
			<div v-if="documentType">
				<form v-on:submit.prevent="updateContents">
					<div v-for="(textVariable) in getContents" :key="textVariable.id" class="row m-0 pt-4">
						<b-form-group class="col-lg-12 m-0 p-0">
							<b-input-group>
								<b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
										<b-input-group-text slot="prepend" class="col-12 pretext">
											<span class="pretext-span">{{textVariable.name}}</span>
										</b-input-group-text>
								</b-input-group-prepend>
								<b-form-textarea id="email_password_reminder" class="txtbox-min-h" v-model="textVariable.content"></b-form-textarea>
							</b-input-group>
						</b-form-group>  
					</div>
					<div class="row pt-4">
						<div class="col-12 text-right">
							<button type="submit" class="btn btn-primary" >{{ t('updateVariableContentsBtn','updateVariableContentsBtn') }}</button>
						</div>
					</div>					
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
	name: 'EditContents',
	components: {
		ResponseInfo
	},
	data() {
		return {
			documentType: null,
			contents: []
		}
	},
	methods: {
		selectDocType() {
			this.$store.dispatch('emailVariablesStore/getTextVariableContnets', {
				docTypeId: this.documentType.id
			}).then(() => {
				//this.contents = this.$store.getters['emailVariablesStore/getContents']
			})
		},
		updateContents() {
			this.$store.dispatch('emailVariablesStore/updateTextVariableContents', {
				docTypeId: this.documentType.id,
				contents: this.$store.getters['emailVariablesStore/getContents']
			})
		}
	},
	computed: {
		...mapGetters(['getResponseInfo', 'getUserLevel', 'getUserDetails']),
		...mapGetters('emailVariablesStore', ['getTextVariables', 'getAllDocTypes', 'getContents'])
	},
	created() {
		this.$store.dispatch('emailVariablesStore/getAllDocumentTypeList')
	}
}
</script>

<style scoped>
  .block-input-row {
    align-items: center;
    text-align: left;
	}
	.txtbox-min-h{
		min-height: 150px;
	}	
</style>